export const RESET = 'EXSBPERIODTYPE_LIST_RESET'
export const SET_ITEMS = 'EXSBPERIODTYPE_LIST_SET_ITEMS'
export const SET_ERROR = 'EXSBPERIODTYPE_LIST_SET_ERROR'
export const SET_VIEW = 'EXSBPERIODTYPE_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'EXSBPERIODTYPE_LIST_TOGGLE_LOADING'
